import { SelectOptions } from '@/ui/types';
import { concat, flow, map, rangeStep } from 'lodash/fp';
import { t } from '@/ui/i18n/i18n';

export const useDelayRange = () => {
  const getDelayRange = (maxDelay: number, startDelay = 5, stepDelay = 1): SelectOptions => {
    // because 0 occupied with a special value
    const startDelayParam = startDelay === 0 ? 1 : startDelay;

    return flow(
      // step, start (inclusive), max bound (exclusive)
      maxDelayParam => rangeStep(stepDelay)(startDelayParam)(maxDelayParam + 1),
      collection => map(
        (step: number) => ({
          label: t('sensors.delay-minutes', { minutes: step.toString() }),
          value: step,
        }),
        collection,
      ),
      concat([
        {
          label: t('sensors.no-delay'),
          value: 0,
        },
      ]),
    )(maxDelay);
  };

  return { getDelayRange };
};
